import React, { Component } from 'react';
import logo_pop from '../assets/images/logo-pop.png';

export default class EDSHeader extends Component {
    render() {
        return (
            <header className="header">
                <div className="header__image-box">
                    <a href="">
                        <img
                            src={logo_pop}
                            alt="Logo Egurrola Dance Studio"
                            className="header__image"
                        />
                    </a>
                </div>
                <div className="header__caption-box">
                    <span className="header__caption">Proces zakupu kursu</span>
                </div>
            </header>
        );
    }
}
